module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"ms":"м/с","km":"км"},"en":{"ms":"ms","km":"km"}}')
  delete Component.options._Ctor
}
